<template>
    <v-dialog v-model="showDateDialog" width="290px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="primary ma-2"
                v-on="on"
                v-bind="attrs"
                v-bind:loading="$store.state.app.loading"
            >
                <v-icon>mdi-calendar</v-icon>
                <v-card-text>{{
                    new Date(date) | date('dd-MMM-yyyy')
                }}</v-card-text>
            </v-btn>
        </template>
        <v-date-picker v-model="datepickerDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" v-on:click="showDateDialog = false"
                >Cancel</v-btn
            >
            <v-btn text color="primary" v-on:click="onDateChange">OK</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
export default {
    props: {
        date: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showDateDialog: false,
            selectedDate: new Date()
        };
    },
    computed: {
        // Date picker accepts yyyy-MM-dd format
        // Set value to a temporary field to emit it
        datepickerDate: {
            get() {
                return this.$options.filters.date(
                    new Date(this.date),
                    'yyyy-MM-dd'
                );
            },
            set(value) {
                this.selectedDate = value;
            }
        }
    },
    methods: {
        onDateChange() {
            this.showDateDialog = false;
            this.$emit('date-change', this.selectedDate);
        }
    }
};
</script>
